<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <v-btn text color="warning" :to="{ name: 'invoicesList' }" class="ma-0 mb-2"><v-icon left>arrow_back</v-icon> All Invoices</v-btn>

                <div v-if="invoiceLoaded && viewInvoice" v-cloak>
                    <h1 class="grey--text lighten-3 mb-2">
                        Invoice: #{{ invoiceDetail.inv_id }}
                        <v-btn :to="{ name: 'invoicePayment', params: { invoice_id: invoiceDetail.inv_id } }" v-if="invoiceDetail.inv_paid == 'No'" dark color="primary"
                            ><v-icon small left dark color="white" style="margin-right: 6px;">add_circle</v-icon> ADD PAYMENT</v-btn
                        >
                    </h1>

                    <v-card>
                        <v-container container--fluid grid-list-lg class="pa-0">
                            <v-layout row wrap class="pa-2 ma-0">
                                <v-flex xs12>
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">library_books</v-icon>Invoice Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item cols-3 text-left">Member / Team</div>
                                                <div class="Ftable__item text-left">Due Date</div>
                                                <div class="Ftable__item text-left">Fully Paid</div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item cols-3 text-left">
                                                    <span>{{ invoiceDetail.inv_invoiceable }}</span>
                                                </div>
                                                <div class="Ftable__item text-left">
                                                    <span>{{ moment(invoiceDetail.inv_due_date).format("DD/MM/YYYY") }}</span>
                                                </div>
                                                <div class="Ftable__item text-left">
                                                    <span>{{ invoiceDetail.inv_paid }}</span>
                                                </div>
                                            </div>
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item cols-3 text-left">Description</div>
                                                <div class="Ftable__item text-right">Qty</div>
                                                <div class="Ftable__item text-right">Unit $</div>
                                                <div class="Ftable__item text-right">Sub Total</div>
                                            </div>
                                            <div class="Ftable__row" v-for="product in invoiceDetail.inv_products" :key="product.pid">
                                                <div class="Ftable__item cols-3 text-left">
                                                    <span>{{ product.opr_name }}</span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ product.opr_quantity }}</span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ product.opr_price | currency }}</span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ product.opr_total | currency }}</span>
                                                </div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item text-left no-border top-border bottom-border">&nbsp;</div>
                                                <div class="Ftable__item text-left no-border top-border bottom-border">&nbsp;</div>
                                                <div class="Ftable__item text-left no-border top-border bottom-border">&nbsp;</div>
                                                <div class="Ftable__item text-right no-border top-border bottom-border right-border">&nbsp;</div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item cols-3 text-left no-border top-border">
                                                    <span></span>
                                                </div>
                                                <div class="Ftable__item text-left no-border top-border right-border">
                                                    <span></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span><strong>Discount</strong></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ invoiceDetail.inv_discount | currency }}</span>
                                                </div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item cols-3 text-left no-border">
                                                    <span></span>
                                                </div>
                                                <div class="Ftable__item text-left no-border right-border">
                                                    <span></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span><strong>Tax</strong></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ taxTotal | currency }}</span>
                                                </div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item cols-3 text-left no-border">
                                                    <span></span>
                                                </div>
                                                <div class="Ftable__item text-left no-border right-border">
                                                    <span></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span><strong>Total</strong></span>
                                                </div>
                                                <div class="Ftable__item text-right">
                                                    <span>{{ grandTotal | currency }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 v-if="invoiceDetail.inv_booking">
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">event</v-icon>Booking Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text" v-if="invoiceDetail.inv_bookings && invoiceDetail.inv_bookings.length > 0">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item cols-25 text-left">Date / Time</div>
                                                <div class="Ftable__item cols-15 text-left">Venue</div>
                                                <div class="Ftable__item cols-15 text-left">Sport</div>
                                                <div class="Ftable__item cols-15 text-left">Court</div>
                                                <div class="Ftable__item cols-15 text-left">Type</div>
                                                <div class="Ftable__item cols-15 text-left">Option</div>
                                            </div>
                                            <template v-for="booking in invoiceDetail.inv_bookings">
                                                <div class="Ftable__row" :key="booking.b_id">
                                                    <div class="Ftable__item cols-25 text-left bottom-border">
                                                        <span><b>From:</b> {{ moment(booking.b_from).format("DD/MM/YYYY hh:mm a") }}</span><br>
                                                        <span><b>To:</b> {{ moment(booking.b_to).format("DD/MM/YYYY hh:mm a") }}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_venue}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_sport}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_space}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_type}}</span>
                                                    </div>
                                                    <div class="Ftable__item cols-15 text-left bottom-border">
                                                        <span>{{booking.b_option}}</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12>
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">attach_money</v-icon>Payment Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text" v-if="invoiceDetail.inv_payments && invoiceDetail.inv_payments.length > 0">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item text-left">Date</div>
                                                <div class="Ftable__item text-left">Method</div>
                                                <div class="Ftable__item text-left">Member</div>
                                                <div class="Ftable__item text-right">Amount</div>
                                            </div>
                                            <template v-for="payment in invoiceDetail.inv_payments">
                                                <div class="Ftable__row" :key="payment.p_id">
                                                    <div class="Ftable__item text-left bottom-border">
                                                        <span>{{ moment(payment.p_date).format("DD/MM/YYYY hh:mm a") }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <span>{{ payment.p_origin | capitalize }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <div>{{ payment.p_member | capitalize }}</div>
                                                    </div>
                                                    <div class="Ftable__item text-right">
                                                        <span>{{ displayAmount(payment) | currency }}</span>
                                                    </div>
                                                </div>
                                                <div class="Ftable__row" v-if="payment.p_discount > 0" :key="payment.p_id + '-discount'">
                                                    <div class="Ftable__item text-left bottom-border">
                                                        <span>{{ moment(payment.p_date).format("DD/MM/YYYY hh:mm a") }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <span>{{ payment.p_origin | capitalize }} - {{ payment.p_discount_orig | capitalize }}</span>
                                                    </div>
                                                    <div class="Ftable__item text-left">
                                                        <div>{{ payment.p_member | capitalize }}</div>
                                                    </div>
                                                    <div class="Ftable__item text-right">
                                                        <span>{{ payment.p_discount | currency }}</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="Ftable black--text" v-if="invoiceDetail.inv_payments && invoiceDetail.inv_payments.length == 0">
                                            <div class="Ftable__row">
                                                <div class="Ftable__item text-center no-border top-border bottom-border">No Payment Yet!</div>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-flex>
                                <v-flex class="text-right">
                                    <div>
                                        <b>Amount outstanding:</b>
                                        <span class="px-2" style="color: #f7941b;">
                                            <b>{{ owingPayments(invoiceDetail.inv_amount, invoiceDetail.inv_payments) }}</b>
                                        </span>
                                        <v-btn
                                            :to="{ name: 'invoicePayment', params: { invoice_id: invoiceDetail.inv_id } }"
                                            v-if="invoiceDetail.inv_paid == 'No'"
                                            dark
                                            color="primary"
                                        >
                                            <v-icon small left dark color="white" style="margin-right: 6px;">add_circle</v-icon> ADD PAYMENT
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </div>

                <div class="justify-center align-center layout" v-if="!invoiceLoaded || !viewInvoice"><v-icon left medium>warning</v-icon> No Invoice Data"</div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
import moment from "moment";

export default {
    name: "InvoiceDetailModule",
    components: {
        //
    },
    props: {
        "invoice-id": {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            moment: moment,
            invoiceDetail: {},
            invoiceLoaded: false,
            viewInvoice: true,
        };
    },
    computed: {
        invoices() {
            return this.$store.getters["invoice/invoices"];
        },
        invoice() {
            return this.$store.getters["invoice/invoiceDetailById"](this.invoiceId);
        },
        user() {
            return this.$store.getters["user/getProfile"];
        },
        taxTotal() {
            return this.invoiceDetail.inv_amount / (taxRate + 1);
        },
        grandTotal() {
            return this.invoiceDetail.inv_amount;
        },
    },
    watch: {
        invoices(n, o) {
            let invId = this.invoiceId;
            this.invoiceDetail = _.find(n, function(inv) {
                return inv.inv_id == invId;
            });

            this.invoiceLoaded = true;
            if (_.isEmpty(this.invoiceDetail) && this.invoice === undefined) {
                this.invoiceLoaded = false;
                this.viewInvoice = false;
            }
        },
        invoice() {
            this.invoiceDetail = this.invoice;

            if (!_.isEmpty(this.invoiceDetail)) {
                this.invoiceLoaded = true;
            }
        },
    },
    methods: {
        total(payments) {
            let sum = parseFloat(0.0);
            return payments.reduce(function(sum, payment) {
                let discount = !_.isNil(payment.p_discount) ? payment.p_discount : 0.0;
                let amount = payment.p_amount;

                if (payment.p_refunded) {
                    amount = payment.p_amount * -1;
                }

                return sum + parseFloat(amount) + parseFloat(discount);
            }, 0.0);
        },
        owingPayments(total, payments) {
            let sum = !_.isEmpty(payments) ? this.total(payments) : 0;

            let owing = parseFloat(parseFloat(total) - parseFloat(sum)).toFixed(2);
            return this.$options.filters.currency(owing);
        },
        displayAmount(payment) {
            return payment.p_refunded ? payment.p_amount * -1 : payment.p_amount;
        },
        resetInvoice: function() {
            if (!_.isEmpty(this.invoices)) {
                this.$store.dispatch("invoice/updateInvoices", this.invoices);

                let invId = this.invoiceId;
                this.invoiceDetail = _.find(this.invoices, function(inv) {
                    return inv.inv_id == invId;
                });

                if (!_.isEmpty(this.invoiceDetail)) {
                    this.invoiceLoaded = true;
                }
            }
        },
    },
    beforeCreate() {
        // this.$store.dispatch('user/userRequest');
        if (_.isEmpty(this.$store.getters["invoice/invoices"])) {
            this.$store.dispatch("invoice/invoiceRequest");
        }
    },
    created() {
        this.resetInvoice();
    },
    mounted() {
        if (_.isEmpty(this.invoiceDetail) && this.invoice !== undefined) {
            this.invoiceDetail = this.invoice;
        }

        this.invoiceLoaded = true;
    },
};
</script>

<style lang="scss">
[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

.Ftable {
    $light-color: #ffffff;
    $header-color: #f8c689;
    $dark-color: #f2f2f2;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*border: 1px solid $dark-color;*/
    font-size: 1rem;
    padding: 0;
    margin: 0;
    line-height: 1.5;
    border: 2px solid $light-color;

    .Ftable__row {
        width: 100%;
        display: flex;

        &.Ftable__header {
            font-weight: bold;

            .Ftable__item {
                background: $header-color;
            }
        }

        .Ftable__item {
            flex: 1 1 25%;
            word-break: break-word;
            padding: 0.25em;
            border: 1px solid $light-color;
            background: $dark-color;

            &.cols-2 {
                flex: 1 1 50%;
            }

            &.cols-3 {
                flex: 1 1 75%;
            }

            &.no-border {
                border: 0px solid $light-color;
            }

            &.right-border {
                border-right: 1px solid $light-color;
            }

            &.top-border {
                border-top: 1px solid $light-color;
            }

            &.bottom-border {
                border-bottom: 1px solid $light-color;
            }
        }
    }
}
</style>
